import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';  // Add this
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { HeaderTwoComponent } from './components/layouts/header-two/header-two.component';
import { HeaderThreeComponent } from './components/layouts/header-three/header-three.component';
import { BlogSidebarComponent } from './components/layouts/blog-sidebar/blog-sidebar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { FooterTwoComponent } from './components/layouts/footer-two/footer-two.component';
import { HomeComponent } from './components/pages/home/home.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { BlogFullComponent } from './components/pages/blog-full/blog-full.component';
import { BlogGridComponent } from './components/pages/blog-grid/blog-grid.component';
import { BlogListComponent } from './components/pages/blog-list/blog-list.component';
import { BlogMasonaryComponent } from './components/pages/blog-masonary/blog-masonary.component';
import { BlogSingleComponent } from './components/pages/blog-single/blog-single.component';
import { CartComponent } from './components/pages/cart/cart.component';
import { CheckoutComponent } from './components/pages/checkout/checkout.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { LegalComponent } from './components/pages/legal/legal.component';
import { LocationsComponent } from './components/pages/locations/locations.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { MenuItemOneComponent } from './components/pages/menu-item-one/menu-item-one.component';
import { MenuItemTwoComponent } from './components/pages/menu-item-two/menu-item-two.component';
import { MenuOneComponent } from './components/pages/menu-one/menu-one.component';
import { MenuTwoComponent } from './components/pages/menu-two/menu-two.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { HeaderFourComponent } from './components/layouts/header-four/header-four.component';
import { HeaderInnerComponent } from './components/layouts/header-inner/header-inner.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import {GoogleLoginProvider,FacebookLoginProvider} from 'angularx-social-login';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { OrdersComponent } from './components/pages/orders/orders.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { ToastrModule } from 'ngx-toastr';
import { NgEventBus } from 'ng-event-bus';
import { GiftcardissuanceComponent } from './components/pages/giftcardissuance/giftcardissuance.component';
import { GiftcardComponent } from './components/pages/giftcard/giftcard.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeaderTwoComponent,
    HeaderThreeComponent,
    BlogSidebarComponent,
    PreloaderComponent,
    FooterComponent,
    FooterTwoComponent,
    HomeComponent,
    HomeTwoComponent,
    HomeThreeComponent,
    HomeFourComponent,
    AboutUsComponent,
    BlogFullComponent,
    BlogGridComponent,
    BlogListComponent,
    BlogMasonaryComponent,
    BlogSingleComponent,
    CartComponent,
    CheckoutComponent,
    ContactComponent,
    LegalComponent,
    LocationsComponent,
    LoginComponent,
    RegisterComponent,
    MenuItemOneComponent,
    MenuItemTwoComponent,
    MenuOneComponent,
    MenuTwoComponent,
    ErrorComponent,
    HeaderFourComponent,
    HeaderInnerComponent,
    OrdersComponent,
    ProfileComponent,
    GiftcardissuanceComponent,
    GiftcardComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LeafletModule,
	HttpClientModule,
	FormsModule,
	ReactiveFormsModule,
	NgSlimScrollModule,
	TimepickerModule.forRoot(),
	SocialLoginModule,
	BsDatepickerModule.forRoot(),

	BrowserAnimationsModule,
	GooglePlaceModule,
	ToastrModule.forRoot(), // ToastrModule added

  ],
  providers: [
	{
		provide: LocationStrategy,
		useClass: HashLocationStrategy
	},
	{
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        alwaysVisible: false,
        gridOpacity: '0.2', barOpacity: '0.5',
        gridBackground: '#fff',
        gridWidth: '6',
        gridMargin: '2px 2px',
        barBackground: '#fff',
        barWidth: '20',
        barMargin: '2px 2px'
      }
    },
	{
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
			   //live
			   '358222027853-hop9qtnt4kei3d5hr4gmeeftib57r7m7.apps.googleusercontent.com'
			   //localc
			   //'358222027853-kbu1dpkibf55ceh6km1cekopoao6v250.apps.googleusercontent.com'
            )
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('384602909537088')
          }
        ]
      } as SocialAuthServiceConfig,
    },
	NgEventBus,BsDatepickerConfig
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
